module.exports = __webpack_public_path__ + "static/img/models.abe650c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/models.png
// module id = iS1J
// module chunks = 1